
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { scrollToTargetAdjusted } from '../../../utils/ui';
import ComponentsRenderer from '../../ComponentsRenderer';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../store/auth-slice';

const Div = styled.div`
    ${(props) => props.margin && `margin: ${props.margin} !important;`}
    ${(props) => props.padding && `padding: ${props.padding} !important;`}
`;

const preloadSingleImage = (url, callback) => {
    const img = new Image();
    img.src = url;
    img.onload = callback; // Trigger the callback once the image is loaded
};

const CustomSection = (props) => {
    const {
        className,
        components,
        padding,
        margin,
        id = '',
        url,
        urls, // Handle dynamic URLs
        children,
        overlayClass,
        linearGradient,
        path,
        onClick,
        scrollTo
    } = props;

    const history = useHistory();
    const [currentUrl, setCurrentUrl] = useState(url || (urls && urls[0]));
    const [fadeIn, setFadeIn] = useState(true);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const location = useLocation();
    const dispatch = useDispatch();
    // Change image at regular intervals if `urls` is provided
    useEffect(() => {
        if (urls && urls.length > 1) {
            const interval = setInterval(() => {
                setFadeIn(false); // Start fade-out
                const currentIndex = urls.indexOf(currentUrl);
                const nextIndex = (currentIndex + 1) % urls.length;
                const nextImage = urls[nextIndex];

                // Preload the next image before updating
                preloadSingleImage(nextImage, () => {
                    setCurrentUrl(nextImage); // Update only after the image is fully loaded
                    setFadeIn(true); // Start fade-in
                });
            }, 5000); // Change image every 5 seconds
            return () => clearInterval(interval);
        }
    }, [currentUrl, urls]);

    const changePath = (path) => {
        history.push(path);
    };

    const openLoginModal = () => {
            dispatch(authActions.openLoginModal());
        };

    const onClickHandler = (type) => {
        switch (type) {
            case 'CHANGE_PATH':
                return changePath(path);
            case 'SCROLL':
                return scrollToTargetAdjusted(scrollTo);
            case 'LOGIN_AND_CHANGE_PATH':
                 return isAuthenticated ? 
                    changePath(path) : 
                    (changePath(`${location.pathname}?postLoginUrl=${path}`),openLoginModal());                      
            default:
                return;
        }
    };

    return (
        <div
            style={{
                backgroundImage: `linear-gradient(90deg, rgba(${linearGradient?.R}, ${linearGradient?.G}, ${linearGradient?.B}, ${linearGradient?.opacity}), rgba(${linearGradient?.R}, ${linearGradient?.G}, ${linearGradient?.B}, ${linearGradient?.opacity})), url('${currentUrl}')`,
                backgroundRepeat: `${
                    linearGradient?.repeat ? linearGradient?.repeat : 'repeat'
                }`,
                backgroundSize: `${
                    linearGradient?.size ? linearGradient?.size : 'cover'
                }`,
                backgroundPosition: `${linearGradient?.position || 'center'}`,
                opacity: fadeIn ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out' // Smooth fade
            }}
            className={`${className || ''}`}
            id={id}
            onClick={() => onClickHandler(onClick)}
        >
            {overlayClass ? (
                <div
                    className={
                        `${overlayClass}` +
                        ' absolute top-0 bottom-0 left-0 right-0 z-0'
                    }
                ></div>
            ) : null}
            <ComponentsRenderer components={components} />
            {children}
        </div>
    );
};

export default CustomSection;
